import React from 'react';
import { BrowserRouter as Router, Switch, Route } from 'react-router-dom';
import firebase from 'firebase/app';
import 'firebase/auth';
import 'firebase/database';
import './App.css';

import firebaseConfig from './constants/firebaseConfig';
import * as ROUTES from '../src/constants/routes';
import Carregando from './components/Carregando';
import AuthScreen from './screens/Auth/AuthScreen';
import CadastrarScreen from './screens/Cadastrar/CadastrarScreen';
import EsqueciScreen from './screens/Esqueci/EsqueciScreen';
import PrincipalScreen from './screens/Principal/PrincipalScreen';
import AcompanhamentoScreen from './screens/Acompanhamento/AcompanhamentoScreen';
import JogadoresScreen from './screens/Jogadores/JogadoresScreen';
import Auth from './services/Auth';

export default class App extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      tela: Carregando,
    };
    firebase.initializeApp(firebaseConfig);
    this.ambiente = process.env.NODE_ENV;
  }

  async componentWillMount() {
    await Auth.onAuth(async usuario => {
      if (usuario) {
        this.setState({ tela: PrincipalScreen });
      } else {
        this.setState({ tela: AuthScreen });
      }
    });
  }

  render() {
    const { tela } = this.state;
    const ComponenteTela = tela;

    return (
      <Router>
        <div className="App">
          <Switch>
            <Route exact path={ROUTES.LANDING} component={AcompanhamentoScreen} />
            <Route exact path={ROUTES.SELECAO} component={ComponenteTela} />
            <Route path={ROUTES.ENTRAR} component={AuthScreen} />
            <Route path={ROUTES.CADASTRAR} component={CadastrarScreen} />
            <Route path={ROUTES.ESQUECI} component={EsqueciScreen} />
            <Route path={ROUTES.JOGADORES} component={JogadoresScreen} />
          </Switch>
        </div>
      </Router>
    );
  }
}
